<template>
  <div class="overflow-y-scroll">
    <section>
      <div class="form-inline flex-row">
        <label>Name:</label>
        <div>
          <input type="text" placeholder="Name" v-model="editName" />
        </div>
      </div>
      <div class="form-inline flex-row">
        <spinnerButton
          class="submit primary"
          :loading="submitLoading"
          @click.native="buttonClick"
          >Add Metro</spinnerButton
        >
      </div>
    </section>
  </div>
</template>

<script>
import spinnerButton from "@/components/public/SpinnerButton";

export default {
  props: ["submitLoading"],
  components: {
    spinnerButton,
  },
  data() {
    return {
      editName: null,
    };
  },
  created: function () {
    this.initData();
  },
  methods: {
    initData: function () {
      this.editName = null;
    },
    buttonClick: function () {
      this.$emit("buttonClick", this.editName);
    },
  },
};
</script>
